import React from 'react';

const emptySection = props => (
  <div className="empty-section">
    <h3>This playlist is currently empty</h3>
    <span>Find more music you love</span>
  </div>
);

export default emptySection;
